import { css } from "@emotion/react"
import { Editor } from "@progress/kendo-react-editor"
import "@progress/kendo-theme-bootstrap/dist/all.css"

const editorStyles = css`
    .k-editor-content p {
        color: black;
    }
`

const RichTextEditor = ({ tools, contentStyle, content, handleOnChange, handleOnBlur }) => {
    return (
        <div css={editorStyles}>
            <Editor
                tools={tools}
                contentStyle={contentStyle}
                defaultEditMode="div"
                value={content || ""}
                onChange={handleOnChange}
                onBlur={handleOnBlur}
            />
        </div>
    )
}

export default RichTextEditor
